import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';
import { activeJobStore } from './active-job-state.js';

const firebaseListenerDisconnectMethods = [];

/**
 * Sets up real-time Firebase listeners for the given job.
 * @param {string} jobId
 */
function setUpFirebaseListeners(jobId) {
  // Set up a callback to update the geohash in the state when it changes in Firebase
  const geohashChangedSnapshot = (snapshot) => {
    // Set the geohash in the active job's state
    const activeJobState = activeJobStore.getState();
    const geohashData = snapshot.val();
    activeJobState.setGeohash(geohashData);
  };

  // Set up a listener for the geohash field of the job
  const katapultJob = KatapultJob.fromId(jobId);
  const disconnect = katapultJob.onGeohashSnapshot(geohashChangedSnapshot);
  firebaseListenerDisconnectMethods.push(disconnect);
}

/**
 * Disconnects all active Firebase listeners and clear the local list of disconnects.
 */
function disconnectFirebaseListeners() {
  firebaseListenerDisconnectMethods.forEach((disconnect) => disconnect());
  firebaseListenerDisconnectMethods.length = 0;
}

/**
 * Clears the active job from the state and disconnects any active Firebase listeners
 */
export function clearActiveJob() {
  disconnectFirebaseListeners();
  activeJobStore.getState().clear();
}

/**
 * Sets the active job by cleaning up the old job and setting up new listeners
 * @param {string} jobId
 */
export function setActiveJob(jobId) {
  clearActiveJob();
  activeJobStore.getState().setId(jobId);
  setUpFirebaseListeners(jobId);
}

/**
 * Gets the ID of the active job from the active job state.
 * @returns {string|null} The active job ID, or null if no job is active.
 */
export function getActiveJobId() {
  return activeJobStore.getState().id;
}
